import * as Utilities from '../forum/utilities';
document.addEventListener('DOMContentLoaded', () => {
    // Numeric Spinner Inputs
    document.querySelectorAll("input[type='number']").forEach((input) => {
        var _a, _b;
        // create wrapper div if not exist
        if (!input.parentNode || !input.parentNode.classList.contains('input-group')) {
            const wrapDiv = document.createElement('div');
            wrapDiv.classList.add('input-group');
            Utilities.wrap(input, wrapDiv);
        }
        // Insert minus button
        const minusButton = document.createElement('button');
        minusButton.classList.add('btn', 'btn-secondary', 'bootstrap-touchspin-down');
        minusButton.type = 'button';
        minusButton.addEventListener('click', touchSpinDown);
        minusButton.innerHTML = '<i class="fa-solid fa-minus"></i>';
        (_a = input.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(minusButton, input);
        // Insert plus button
        const plusButton = document.createElement('button');
        plusButton.classList.add('btn', 'btn-secondary', 'bootstrap-touchspin-up');
        plusButton.type = 'button';
        plusButton.addEventListener('click', touchSpinUp);
        plusButton.innerHTML = '<i class="fa-solid fa-plus"></i>';
        (_b = input.parentNode) === null || _b === void 0 ? void 0 : _b.append(plusButton);
    });
    function touchSpinDown() {
        var _a;
        const btn = this;
        const input = btn.nextSibling;
        const oldValue = input.value.trim();
        let minValue = 1;
        if (input.classList.contains('form-control-days')) {
            minValue = parseInt((_a = input.dataset.min) !== null && _a !== void 0 ? _a : '1');
        }
        else if (input.classList.contains('serverTime-Input')) {
            minValue = -720;
        }
        const newVal = parseInt(oldValue) > minValue ? parseInt(oldValue) - 1 : minValue;
        input.value = newVal.toString();
    }
    function touchSpinUp() {
        const btn = this;
        const input = btn.previousSibling;
        const oldValue = input.value.trim();
        let maxValue = 2147483647;
        if (input.classList.contains('serverTime-Input')) {
            maxValue = -720;
        }
        if (parseInt(oldValue) <= maxValue) {
            const newVal = parseInt(oldValue) + 1;
            input.value = newVal.toString();
        }
    }
});
